// --------------------------------------------------------------
// Created On: 2022-05-16
// Author: Zachary Thomas
//
// Last Modified: 2026-09-29
// Modified By: Zachary Thomas
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { useState } from "react";
import Spinner from "../../components/Spinner/Spinner";
import NotificationTable from "./NotificationTable/NotificationTable";
import useApi from "../../hooks/useApi";
import Error500Page from "../Error500Page/Error500Page";
import { API } from "../../constants/miscellaneous";
import useReduxDispatch from "src/hooks/useReduxDispatch";
import { setNotifications } from "src/redux/features/notificationsSlice";

// Page that displays a list of all of the notifications for the current user.
export default function NotificationPage(): Component {
  const [loading, setLoading] = useState<boolean>(false);
  const [failedToLoad, setFailedToLoad] = useState<boolean>(false);
  const dispatch = useReduxDispatch();

  // Get notification data from API.
  useApi(
    () => {
      setLoading(true);
      return true;
    },
    {
      method: "GET",
      url: `${API}/alertmessage/all`,
    },
    async (response: Response, responseBody: ResponseBody) => {
      if (response.ok && responseBody) {
        dispatch(setNotifications(responseBody.alertMessages));
        setFailedToLoad(false);
      } else {
        setFailedToLoad(true);
        console.error("Internal server error. Unable to retrieve notifications.");
      }
      setLoading(false);
    },
    []
  );

  return failedToLoad ? (
    <Error500Page />
  ) : (
    <div className="p-1">
      <Spinner loading={loading} />
      <NotificationTable loading={loading} />
    </div>
  );
}

interface AlertMessage {
  alertMessageId: number;
  alertCode: string;
  date: string;
  message: string;
  unread: boolean;
  urgency: string;
  alertUrl: string;
}

interface ResponseBody {
  alertMessages: AlertMessage[];
}
